import { render, staticRenderFns } from "./AnnualReport.vue?vue&type=template&id=681710e2&scoped=true&"
import script from "./AnnualReport.vue?vue&type=script&lang=ts&"
export * from "./AnnualReport.vue?vue&type=script&lang=ts&"
import style0 from "./AnnualReport.vue?vue&type=style&index=0&id=681710e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681710e2",
  null
  
)

export default component.exports